import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, Protected } from "@/context/AuthContext";
import Home from "@/pages/Home";
import { Login, Register, ForgotPassword, ResetPassword, AuthCallback } from "@/pages/Auth";
import { Policy, Contact, Partner } from "@/pages/Policies";
import { BookReview, BookingConfirmation } from "@/pages/Booking";
import Account, { AccountBooking } from "@/pages/Account";
import DriverPortal from "@/pages/DriverPortal";
import { AdminLayout, AdminList, Overview } from "@/pages/admin/AdminCore";
import { BookingDetail, ApplicationReview, InvoiceDetail } from "@/pages/admin/AdminDetails";
import { RateCardEditor, Config, Users, Reports } from "@/pages/admin/AdminSettings";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const C = (el) => <Protected roles={["customer"]}>{el}</Protected>;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/terms" element={<Policy slug="terms" />} />
      <Route path="/privacy" element={<Policy slug="privacy" />} />
      <Route path="/refund-policy" element={<Policy slug="refund-policy" />} />
      <Route path="/service-policy" element={<Policy slug="service-policy" />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/partner" element={<Partner />} />
      <Route path="/book" element={C(<BookReview />)} />
      <Route path="/booking/:id/confirmation" element={C(<BookingConfirmation />)} />
      <Route path="/account" element={C(<Account />)} />
      <Route path="/account/bookings/:id" element={C(<AccountBooking />)} />
      <Route path="/driver" element={<Protected roles={["driver"]}><DriverPortal /></Protected>} />
      <Route path="/admin" element={<Protected staff><AdminLayout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="list/:entity" element={<AdminList />} />
        <Route path="bookings/:id" element={<BookingDetail />} />
        <Route path="applications/:id" element={<ApplicationReview />} />
        <Route path="invoices/:id" element={<InvoiceDetail />} />
        <Route path="rate-cards/:id" element={<RateCardEditor />} />
        <Route path="config" element={<Config />} />
        <Route path="users" element={<Users />} />
        <Route path="reports" element={<Reports />} />
      </Route>
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
